import { AppQueryOptions, useAppQueryMap } from 'hooks/use-app-query'
import { getLeadTabCount } from 'services/lead'
import { GetLeadTabCountResponse } from 'services/types/lead'
import { LeadTabCount } from 'store/types/lead'
import { leadKey } from 'utils/constants/queryKey'

const useLeadTab = (id: string, queryOptions?: AppQueryOptions) =>
  useAppQueryMap(leadKey.tab(id), () => getLeadTabCount({ lead_id: id }), mapTabCount, {
    enabled: !!id && (queryOptions?.enabled ?? false),
  })

export const mapTabCount = (data: GetLeadTabCountResponse): LeadTabCount => ({
  activityCount: data.activity,
  taskCount: data.task,
  documentCount: data.document,
  fitmentsCount: data.fitment,
  opportunitiesCount: data.opportunity,
})

export default useLeadTab
